// Mục "Hiệu quả kinh doanh": đơn qua app của người tham gia so với người chưa tham gia (tối đa 31 ngày cuối).
import { Alert, Card, Col, Row } from "antd";
import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { faBagShopping, faPercent, faSackDollar } from "@fortawesome/free-solid-svg-icons";
import XuEmptyHint from "./xu-empty-hint";
import XuKpiCard from "./xu-kpi-card";
import { shortDate, useXuChart } from "./xu-chart-style";
import { fmtNum, fmtPct, fmtVnDate } from "./xu-format-helpers";

const vnd = (v) => `${fmtNum(v)}đ`;
const sumOf = (days, who, field) => days.reduce((s, d) => s + (d[who]?.[field] || 0), 0);

export default function XuStatsBusinessSection({ business }) {
    const { chart, tooltip } = useXuChart();
    const { days } = business;
    const known = days.filter((d) => d.others);
    const pOrders = sumOf(days, "participants", "orders");
    const oOrders = sumOf(known, "others", "orders");
    const share = known.length ? Math.round((sumOf(known, "participants", "orders") / Math.max(1, sumOf(known, "participants", "orders") + oOrders)) * 1000) / 10 : null;
    return (
        <Card size="small" title="Người tham gia mua nhiều hơn không?" className="shadow-sm"
            extra={<span className="text-xs text-gray-400">Đơn qua app, tính theo ngày ĐẶT</span>}>
            <div className="space-y-3">
                {business.clipped && <Alert type="info" showIcon message={`Phần này nặng nên chỉ tính 31 ngày cuối: ${fmtVnDate(business.from)} – ${fmtVnDate(business.to)}.`} />}
                {business.truncated && <Alert type="warning" showIcon message={`Chỉ tính ${fmtNum(business.participantCount)} người tham gia đầu tiên (số quá lớn).`} />}
                <Row gutter={[16, 16]}>
                    <Col xs={24} md={8}><XuKpiCard icon={faBagShopping} tone="emerald" title="Đơn của người tham gia" value={fmtNum(pOrders)} unit="đơn"
                        sub={`Người chưa tham gia: ${fmtNum(oOrders)} đơn`} help="Người tham gia = đã có ví Xu (tính cả đơn trước khi họ tham gia). Người chưa tham gia = tổng đơn app trừ đi phần trên." /></Col>
                    <Col xs={24} md={8}><XuKpiCard icon={faPercent} tone="indigo" title="Tỉ trọng đơn của người tham gia" value={fmtPct(share)}
                        sub="Trên tổng đơn app trong khoảng" /></Col>
                    <Col xs={24} md={8}><XuKpiCard icon={faSackDollar} tone="amber" title="Tiền hoàn cho người tham gia" value={vnd(sumOf(days, "participants", "userCommission"))}
                        sub={`Người chưa tham gia: ${vnd(sumOf(known, "others", "userCommission"))}`} help="Chỉ cộng đơn đã duyệt. Đơn gần đây còn tăng vì sàn duyệt dần." /></Col>
                </Row>
                {!pOrders && !oOrders ? <XuEmptyHint title="Chưa có đơn app nào trong khoảng này" hint="Đơn tính theo ngày đặt; đơn sàn báo về muộn sẽ tự cộng thêm khi tải lại." /> : (
                    <ResponsiveContainer width="100%" height={240}>
                        <BarChart data={days.map((d) => ({ label: shortDate(d.vnDate), p: d.participants.orders, o: d.others ? d.others.orders : null }))}>
                            <CartesianGrid stroke={chart.grid} strokeDasharray="3 3" />
                            <XAxis dataKey="label" stroke={chart.axis} fontSize={12} />
                            <YAxis stroke={chart.axis} fontSize={12} allowDecimals={false} />
                            <Tooltip {...tooltip} />
                            <Legend />
                            <Bar dataKey="p" name="Người tham gia" stackId="a" fill={chart.series[2]} />
                            <Bar dataKey="o" name="Chưa tham gia" stackId="a" fill={chart.series[1]} radius={[3, 3, 0, 0]} />
                        </BarChart>
                    </ResponsiveContainer>
                )}
            </div>
        </Card>
    );
}
